import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from './services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignatureService } from './services/signature.service';
import { AccountSignature } from './pages/signature/signature.interface';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LeadDetailsModalComponent } from './pages/cases/components/lead-details-modal/lead-details-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public update: boolean = false;
  public version;
  readonly envBadge = environment.envBadge ?? null;
  readonly envBadgeDevelop = this.envBadge === 'develop';
  readonly envBadgeStaging = this.envBadge === 'staging';
  private accountSignature: AccountSignature;
  constructor(
    loginService: LoginService,
    signatureService: SignatureService,
    snack: MatSnackBar,
    router: Router,
    private readonly dialog: MatDialog
  ) {
    const rotas = [
      '#/login',
      '#/reset-password',
      '#/invitation',
      '#/register',
      '#/beta',
    ];

    if (!rotas.some((route) => window.location.hash.startsWith(route))) {
      signatureService.getAccountSignature().subscribe((res) => {
        if (res) this.accountSignature = res.data;
      });
    }

    loginService.notification$.subscribe((notification) => {
      snack.open(notification.message, 'OK', {
        duration: notification.duration || 5000,
      });
    });
  }
// Demonstração de teste de modal
//   openLeadModal(): void {
//     this.dialog.open(LeadDetailsModalComponent, {
//       data: { leadId: 1 },
//       maxWidth: '720px',
//       width: 'calc(100vw - 32px)',
//       position: { top: '10vh' },
//       panelClass: 'lead-details-dialog',
//     });
//   }
}
